export const OSM_STYLE = {
  version: 8,
  sources: {
    'osm-raster': {
      type: 'raster',
      tiles: ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'],
      tileSize: 256,
      attribution: '&copy; OpenStreetMap Contributors'
    }
  },
  layers: [
    {
      id: 'osm-raster-layer',
      type: 'raster',
      source: 'osm-raster',
      minzoom: 0,
      maxzoom: 19
    }
  ]
};

export const SATELLITE_STYLE = {
  version: 8,
  sources: {
    'satellite': {
      type: 'raster',
      tiles: ['https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'],
      tileSize: 256,
      attribution: '&copy; Esri, Maxar, GeoEye, Earthstar Geographics, CNES/Airbus DS, USDA, USGS, AeroGRID, IGN, and the GIS User Community'
    }
  },
  layers: [
    {
      id: 'satellite-layer',
      type: 'raster',
      source: 'satellite',
      minzoom: 0,
      maxzoom: 19
    }
  ]
};

export const DARK_STYLE = {
  version: 8,
  sources: {
    'carto-dark': {
      type: 'raster',
      tiles: ['https://a.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png'],
      tileSize: 256,
      attribution: '&copy; OpenStreetMap Contributors, &copy; CARTO'
    }
  },
  layers: [
    {
      id: 'carto-dark-layer',
      type: 'raster',
      source: 'carto-dark',
      minzoom: 0,
      maxzoom: 19
    }
  ]
};

export const LIGHT_STYLE = {
  version: 8,
  sources: {
    'carto-light': {
      type: 'raster',
      tiles: ['https://a.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png'],
      tileSize: 256,
      attribution: '&copy; OpenStreetMap Contributors, &copy; CARTO'
    }
  },
  layers: [
    {
      id: 'carto-light-layer',
      type: 'raster',
      source: 'carto-light',
      minzoom: 0,
      maxzoom: 19
    }
  ]
};

export const TERRAIN_STYLE = {
  version: 8,
  sources: {
    'carto-terrain': {
      type: 'raster',
      tiles: ['https://a.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png'],
      tileSize: 256,
      attribution: '&copy; OpenStreetMap Contributors, &copy; CARTO'
    }
  },
  layers: [
    {
      id: 'carto-terrain-layer',
      type: 'raster',
      source: 'carto-terrain',
      minzoom: 0,
      maxzoom: 19
    }
  ]
};

export const BASEMAPS = {
  osm: {
    id: 'osm',
    name: 'OpenStreetMap',
    style: OSM_STYLE
  },
  satellite: {
    id: 'satellite',
    name: 'Satellite',
    style: SATELLITE_STYLE
  },
  dark: {
    id: 'dark',
    name: 'Dark',
    style: DARK_STYLE
  },
  light: {
    id: 'light',
    name: 'Light',
    style: LIGHT_STYLE
  },
  terrain: {
    id: 'terrain',
    name: 'Terrain',
    style: TERRAIN_STYLE
  }
};

export const INITIAL_MESSAGES = [
  {
    role: 'assistant',
    content: "Hello! I'm the manteo.ai assistant. I can help analyze your datasets. How can I assist you today?",
    suggestions: [
      'What questions can you answer?',
      'Brief description of the available datasets',
      'How can I visualize my data on a map?',
    ]
  }
];
